import { z } from "zod";
import { zString } from "../../../config/schemas/commonSchemaObjects";

export const addNewEntitySchema = z.object({
  entity_name: zString.zRequired,
  parent: zString.zOptional,
  description: zString.zRequired,
});
